import styled from 'styled-components';

export const ProgramCostStyles = styled.div`
  padding: 100px 0 64px;
  background: #FFC228;
  
  @media (max-width: 800px) {
    padding: 56px 0 32px;
  }
  
  .head {
    max-width: 878px;
    
    margin-bottom: 40px;

    @media (max-width: 800px) {
      max-width: 550px;
    }
    
    h2 {
      margin-bottom: 24px;
      
      font-weight: 800;
      font-size: 44px;
      line-height: 66px;

      letter-spacing: 0.02em;
      color: #0F0F0F;

      @media (max-width: 800px) {
        font-size: 22px;
        line-height: 34px;
      }
    }
    
    .descriptionWrapper {
      display: grid;
      gap: 16px;
    }
    
    .listWrapper {
      .caption {
        display: block;
        margin-bottom: 12px;
        
        font-weight: 800;
        font-size: 22px;
        line-height: 34px;

        @media (max-width: 800px) {
          font-size: 18px;
          line-height: 26px;
          
          font-weight: 700;
        }
      }
      
      ul {
        margin-bottom: 16px;

        @media (max-width: 800px) {
          margin-bottom: 24px;
        }
        
        li {
          position: relative;
          display: flex;
          padding-left: 24px;

          font-weight: 400;
          font-size: 18px;
          line-height: 28px;
          color: #0F0F0F;
          
          transition: 0.5s ease-in all;
          opacity: 0;
          transform: translateY(10px);
          
          &.active {
            opacity: 1;
            transform: translateY(0);
          }

          @media (max-width: 800px) {
            font-size: 16px;
            line-height: 24px;
          }
          
          &:not(:last-child) {
            margin-bottom: 8px;
          }
          
          &::after {
            content: '';
            position: absolute;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            margin-right: 12px;
            background: #000;
            left: 0;
            top: 9px;
            
            @media (max-width: 800px) {
              top: 6px;
            }
          }
        }
      }
      
      .subdescription {
        opacity: 0;
        transition: 1s opacity ease-in;

        &.active {
          opacity: 1;
        }
      }
      
      .description {
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        max-width: 753px;
        
        opacity: 0;
        transition: 1s opacity ease-in;
        
        &.active {
          opacity: 1;
        }

        @media (max-width: 800px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
  
  .list {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    
    > li {

      height: auto;
      overflow: hidden;
      
      @media (max-width: 800px) {
        padding: 32px 16px;
      }
      
      &.active {
        .contentWrapper {
          opacity: 1;
        }
      }
      
      .contentWrapper {
        opacity: 0;
        transition: 1s linear all;

        background: #1B1F2C;
        padding: 32px;
        box-sizing: border-box;
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 24px;
        grid-auto-flow: row;
      }
      
      .button {
        width: 100%;
      }

      .itemHead {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
      }
      
      h3 {
        font-weight: 800;
        font-size: 44px;
        line-height: 66px;
        letter-spacing: 0.02em;
        color: #FFC228;
        margin-bottom: 24px;

        @media (max-width: 800px) {
          font-size: 22px;
          line-height: 34px;
        }
      }
      
      .price {
        font-weight: 800;
        font-size: 22px;
        line-height: 34px;
        color: #FFC228;
        margin-bottom: 24px;

        @media (max-width: 800px) {
          font-size: 22px;
          line-height: 34px;
        }
      }
      
      ul {
        display: grid;
        gap: 4px;
        margin-bottom: 24px;
        
        li {
          position: relative;
          padding-left: 24px;
          
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          &::after {
            content: '';
            position: absolute;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            margin-right: 12px;
            background: #FFC228;
            left: 0;
            top: 9px;

            @media (max-width: 800px) {
              top: 6px;
            }
          }
          
          span {
            font-weight: 400;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;

            @media (max-width: 800px) {
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
`;
